// components/CustomEdge.js
import React from 'react';
import { getBezierPath, getSmoothStepPath, getSimpleBezierPath, getStraightPath } from '@xyflow/react'; // Use ReactFlow's built-in Bezier logic

const CustomEdge = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerStart,
  markerEnd,
  animated = false,
  label,
  labelStyle = {},
  labelBgStyle = {},
  selected, // Add selected prop
  data
}) => {

  // Determine the path based on the connectorType
  const getPath = () => {
    switch (data.connectorType) {
      case 'smoothstep':
        return getSmoothStepPath({
          sourceX,
          sourceY,
          sourcePosition,
          targetX,
          targetY,
          targetPosition,
        });
      case 'simplebezier':
        return getSimpleBezierPath({
          sourceX,
          sourceY,
          sourcePosition,
          targetX,
          targetY,
          targetPosition,
        });
      case 'straight':
        return getStraightPath({
          sourceX,
          sourceY,
          sourcePosition,
          targetX,
          targetY,
          targetPosition,
        });
      case 'bezier':
      default:
        return getBezierPath({
          sourceX,
          sourceY,
          sourcePosition,
          targetX,
          targetY,
          targetPosition,
        });
    }
  };

  // const [edgePath] = getPath(() => {
  //   console.log("connectorType", connectorType);
  //   return connectorType
  // });

  const [edgePath] = getPath();

  // Adjust Selected Stroke Width - Highlighting
  const adjustStrokeWidth = (strokeWidth) => {
    const parsedStrokeWidth = parseFloat(strokeWidth) || 1; // Default to 1 if invalid
    return parsedStrokeWidth < 3 ? parsedStrokeWidth + 1 : parsedStrokeWidth * 1.3;
  };

  return (
    <>
      {/* Add the SVG filter definition */}
      {/* <svg style={{ position: 'absolute', width: 0, height: 0 }}>
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="5" result="coloredBlur" />
            <feDiffuseLighting in="SourceGraphic" result="light" lighting-color="white">
              <fePointLight x="150" y="60" z="20" />
            </feDiffuseLighting>
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg> */}
      
      {/* Invisible path to increase clickable area */}
      <path
        id={`${id}-clickable`}
        d={edgePath}
        style={{ fill: 'none', stroke: 'none', strokeWidth: 10, strokeDasharray: '0' }}
        className="react-flow__edge-path"
      />
      {/* Selected path */}
      {selected && (
        <path
          id={id}
          style={{
            fill: 'none',
            stroke: style.stroke,
            // strokeWidth: (parseFloat(style.stroke) || 0) + 3, // Parse stroke as a number and add
            strokeWidth: adjustStrokeWidth(style.strokeWidth), // Use the function
            strokeDasharray: style.strokeDasharray,
            filter: 'url(#glow)', // Apply a glow effect using a filter
          }}
          className="react-flow__edge-path"
          d={edgePath}
        />
      )}

      {/* Visible path */}
      <path
        id={id}
        style={{
          ...style, // Spread any additional styles from the `style` object
          stroke: style.stroke, // Ensure `stroke` is applied from the style object
          strokeWidth: style.strokeWidth
        }}
        // CONDITIONAL SELECTION FORMATTING
        className="react-flow__edge-path z-50" // Default class for React Flow edges
        d={edgePath} // The path data for the edge
        // markerEnd={markerEnd} // Apply markerEnd property
      />
      {/* Dashed path for animation */}
      {animated && (
        <path
          d={edgePath}
          className="react-flow__edge-path animated z-50"
          style={{ ...style, strokeDasharray: '5,5' }}
        />
      )}

      {/* Invisible path for the marker */}
      <path
        id={`${id}-marker`}
        d={edgePath}
        style={{ fill: 'none', stroke: 'none', strokeWidth: 1 }} // Consistent stroke width for marker
        markerEnd={markerEnd} // Apply markerEnd property
        className="react-flow__edge-path"
      />

      {/* Label */}
      {label && (
        <text>
          <textPath
            href={`#${id}`}
            style={labelStyle}
            startOffset="50%"
            textAnchor="middle"
          >
            {label}
          </textPath>
          <rect
            x={targetX - 50}
            y={targetY - 10}
            width={100}
            height={20}
            style={labelBgStyle}
          />
        </text>
      )}
    </>
  );
};

export default CustomEdge;